import { Config } from 'modules/config/state/config-types'
import { FlowSlice, FlowStep, FlowSteps } from '../flow-types'
import { URLParams } from 'modules/url-params/state/app-url-params-types'
import { DONATION_STEP_NAME, makeDonationStep } from './steps/donation'
import makeRecurringNudgeStep, { RECURRING_NUDGE_STEP_NAME } from './steps/recurring-nudge'
import makePaymentMethodsStep, { PAYMENT_METHODS_STEP_NAME } from './steps/payment-method'
import makeCardDetailsStep from './steps/card-details'
import makeBankDetailsStep from './steps/bank-details'
import makeOptionsStep from './steps/options'
import makeDonorInformationStep from './steps/donor-information'
import { makeAdditionalDonorInformationStep } from './steps/additional-donor-information'
import { makeDesignationStep } from './steps/designation'
import { makeDedicationSteps } from './steps/dedication'
import makeDoubleTheDonationStep from './steps/double-the-donation'
import makeCustomQuestionSteps from './steps/custom-questions'
import makeCommentStep from './steps/comment'
import { makeThankYouStep } from './steps/thank-you'
import makeDCFNudgeStep from './steps/dcf-nudge'

const makeFlowInitialState = (config: Config, urlParams: URLParams): FlowSlice => {
  const stepsArr = [
    makeDonationStep(), // TODO
    makeRecurringNudgeStep(config, urlParams),
    makePaymentMethodsStep(), // TODO
    makeCardDetailsStep(), // TODO
    makeBankDetailsStep(), // TODO
    makeDCFNudgeStep(config),
    makeOptionsStep(config),
    ...makeCustomQuestionSteps(config, true),
    makeDonorInformationStep(),
    makeAdditionalDonorInformationStep(config),
    makeDesignationStep(config),
    ...makeDedicationSteps(config),
    makeDoubleTheDonationStep(config),
    ...makeCustomQuestionSteps(config, false),
    makeCommentStep(config),
    makeThankYouStep(),
  ]

  const stepsMap = stepsArr.reduce((acc, cur, index) => {
    const step: FlowStep = {
      ...cur,
      index, // IMPORTANT: Override the default index of -1
    }

    return { ...acc, [step.name]: step }
  }, {} as FlowSteps)

  const initialStepName = makeInitialStepName(urlParams, stepsMap)

  const currentStep = stepsMap[initialStepName]
  currentStep.numVisits = 1

  return {
    stepsMap,
    currentStepName: initialStepName,
  }
}

export default makeFlowInitialState

const makeInitialStepName = (urlParams: URLParams, stepsMap: FlowSteps) => {
  const { frequency, amount } = urlParams

  if (!frequency || !amount) {
    return DONATION_STEP_NAME
  }

  if (stepsMap[RECURRING_NUDGE_STEP_NAME].enabled) {
    return RECURRING_NUDGE_STEP_NAME
  }

  return PAYMENT_METHODS_STEP_NAME
}
